import { useState } from "react";
import DevoteeHallBooking from "./DevoteeHallBooking";
import HallSchedule from "../HallSchedule/HallSchedule";

interface HallRentalProps {
  onBackClick: () => void;
}

const HallRental = (props: HallRentalProps) => {
  const [showHallScheduleScreen, setShowHallScheduleScreen] =
    useState<boolean>(false);

  return (
    <>
      {!showHallScheduleScreen ? (
        <DevoteeHallBooking
          onBackClick={props?.onBackClick}
          setShowHallScheduleScreen={setShowHallScheduleScreen}
        />
      ) : (
        <HallSchedule setShowHallScheduleScreen={setShowHallScheduleScreen} />
      )}
    </>
  );
};

export default HallRental;
